import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { goToCampaignDetails } from '../../../../../store/navigation/campaigns/thunks';
import BackToCampaignDetailsButton from './BackToCampaignDetailsButton';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      goToCampaignDetails,
    },
    dispatch,
  );

class BackToCampaignDetailsButtonContainer extends React.Component {
  goToCampaignDetails = () => {
    const campaignIdFromUrl = this.props.match.params.campaignId;

    if (campaignIdFromUrl) {
      this.props.goToCampaignDetails(campaignIdFromUrl);
    } else {
      toastr.error('Error', 'Could not read campaign ID from URL');
    }
  };

  render() {
    return <BackToCampaignDetailsButton onClick={this.goToCampaignDetails} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BackToCampaignDetailsButtonContainer));
